import { Badge, createListCollection, Field, HStack, Input, Portal, Select, Table, VStack } from "@chakra-ui/react";
import React, { useEffect, useRef, useState } from "react";
import { useDispatch } from "react-redux";
import { formatDateTime } from "../Utils/newHelper";
import { TransactionInfoDialog } from "../Components/custom/TransactionInfoDialog";
import AllTransactionsSkeleton from "../Components/custom/Skeletons/AllTransactionsSkeleton";
import { CustomPagination } from "../Components/custom/CustomPagination";
import { getTransactionList } from "../Redux/Action";
import { PAGINATION } from "../Utils/Constants";
import DateRangeFilter from "../Components/custom/DateRangeFilter";
import { getLocalStorageItem } from "../Utils/Helper";
import { setDynamicTitle } from "../Utils/dynamicTitleManager";

export const AllTransactions = () => {
  // Use dynamic title management
  useEffect(() => {
    setDynamicTitle("All Transactions");
  }, []);

  const didMountRef = useRef(false);
  const [allTransactions, setAllTransactions] = useState([]);
  const [isDataLoading, setisDataLoading] = useState(true);
  const [transactionInfoDialogOpen, setTransactionInfoDialogOpen] = useState(false);
  const now = new Date();
  const oneDayAgo = new Date(now.getTime() - 24 * 60 * 60 * 1000);
  const [from, setFrom] = useState(formatDate(oneDayAgo));
  const [to, setTo] = useState(formatDate(now));
  const [totalPages, setTotalPages] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [type, setType] = useState("all");
  const [selectedToken, setSelectedToken] = useState("");
  const [status, setStatus] = useState("all");
  const whitelabelData = getLocalStorageItem("whitelabelData")
  const frameworks = createListCollection({
    items: [
      { label: "All", value: "all" },
      { label: "deposit", value: "deposit" },
      { label: "withdraw", value: "withdraw" },
      { label: "crypto", value: "crypto" },
    ],
  });

  const statuses = createListCollection({
    items: [
      { label: "All", value: "all" },
      { label: "Pending", value: "pending" },
      { label: "Rejected", value: "rejected" },
      { label: "Declined", value: "declined" },
      { label: "Cancelled", value: "cancelled" },
      { label: "Success", value: "success" },
      { label: "Accepted", value: "accepted" },
    ],
  });

  const dispatch = useDispatch();

  function formatDate(date) {
    return date.toISOString().split("T")[0];
  }

  const fetchData = () => {
    const payload = {
      ...(whitelabelData?._id != null && { whitelabelId: whitelabelData._id }),
      date_from: from,
      date_to: to,
      per_page: PAGINATION.PER_PAGE,
      page: currentPage,
      currency: "USD",
      ...(type && { type }),
      ...(status && { status }),
    };
    setisDataLoading(true);
    dispatch(
      getTransactionList({
        payload,
        callback: (data) => {
          if (data?.meta?.code === 200) {
            setAllTransactions(data?.data?.transactionsData);
            setTotalPages(data?.data?.pagination?.totalPages);
            setisDataLoading(false);
          }
        },
      })
    );
  };

  useEffect(() => {
 

    if (didMountRef.current) {
   
      const timer = setTimeout(fetchData(from, to), 500);
      return () => clearTimeout(timer);
    } else {
  
      fetchData(from, to);
      didMountRef.current = true;
    }
  }, [type, currentPage, status, from, to]);

  return (
    <VStack>
      <HStack width="100%" justifyContent="space-between">
        <DateRangeFilter
          initialFrom={from}
          initialTo={to}
          onApply={({ from, to }) => {
            setFrom(from);
            setTo(to);
          }}
          isLoading={isDataLoading}
        />

        
        <HStack width="30%" justifyContent="flex-end" spacing={4}>
       
          <Select.Root
            collection={frameworks}
            width="100%"
            disabled={isDataLoading}
            onChange={(e) => {
              setType(e?.target?.value);
              setCurrentPage(1);
            }}
            deselectable
            defaultValue={["all"]}
          >
            <Select.HiddenSelect />
            <Select.Label>Select Transaction Type</Select.Label>
            <Select.Control>
              <Select.Trigger>
                <Select.ValueText placeholder="Transaction Type" />
              </Select.Trigger>
              <Select.IndicatorGroup>
                <Select.ClearTrigger />
                <Select.Indicator />
              </Select.IndicatorGroup>
            </Select.Control>
            <Portal>
              <Select.Positioner>
                <Select.Content>
                  {frameworks.items.map((framework) => (
                    <Select.Item item={framework} key={framework.value}>
                      {framework.label}
                      <Select.ItemIndicator />
                    </Select.Item>
                  ))}
                </Select.Content>
              </Select.Positioner>
            </Portal>
          </Select.Root>

          {/* Status Filter */}
          <Select.Root
            collection={statuses}
            width="100%"
            disabled={isDataLoading}
            onChange={(e) => {
              setStatus(e?.target?.value);
              setCurrentPage(1);
            }}
            deselectable
            defaultValue={["all"]}
          >
            <Select.HiddenSelect />
            <Select.Label>Select Status</Select.Label>
            <Select.Control>
              <Select.Trigger>
                <Select.ValueText placeholder="Status" />
              </Select.Trigger>
              <Select.IndicatorGroup>
                <Select.ClearTrigger />
                <Select.Indicator />
              </Select.IndicatorGroup>
            </Select.Control>
            <Portal>
              <Select.Positioner>
                <Select.Content>
                  {statuses.items.map((status) => (
                    <Select.Item item={status} key={status.value}>
                      {status.label}
                      <Select.ItemIndicator />
                    </Select.Item>
                  ))}
                </Select.Content>
              </Select.Positioner>
            </Portal>
          </Select.Root>
        </HStack>
      </HStack>

      {isDataLoading ? (
        <AllTransactionsSkeleton />
      ) : (
        <>
          <Table.ScrollArea borderWidth="1px" rounded="md" maxHeight="70vh" width="100%">
            <Table.Root interactive variant="outline" stickyHeader>
              <Table.Header>
                <Table.Row>
                  <Table.ColumnHeader width="10%">Sr.No.</Table.ColumnHeader>
                  <Table.ColumnHeader width="14%" textAlign="center">
                    User Account
                  </Table.ColumnHeader>
                  <Table.ColumnHeader width="14%" textAlign="center">
                    Amount
                  </Table.ColumnHeader>
                  <Table.ColumnHeader width="14%" textAlign="center">
                    Type
                  </Table.ColumnHeader>
                  <Table.ColumnHeader width="14%" textAlign="center">
                    method
                  </Table.ColumnHeader>
                  <Table.ColumnHeader width="14%" textAlign="center">
                    Status
                  </Table.ColumnHeader>
                  <Table.ColumnHeader width="14%" textAlign="center">
                    Created At
                  </Table.ColumnHeader>
                  {/* <Table.ColumnHeader width="14%" textAlign="center">
                    Actions
                  </Table.ColumnHeader> */}
                </Table.Row>
              </Table.Header>
              <Table.Body>
                {allTransactions?.length ? (
                  allTransactions?.map((item) => (
                    <Table.Row key={item._id}>
                      <Table.Cell>{item._id}</Table.Cell>
                      <Table.Cell textAlign="center">{item?.moneyPlantAccountNo}</Table.Cell>
                      <Table.Cell textAlign="center">
                        {item?.amount}&nbsp;
                        {item?.user?.currency}
                      </Table.Cell>
                      {/* <Table.Cell textAlign="center">
                      <VStack>
                        <Badge variant="surface" colorPalette="teal" size="xs">
                          {item.card_type}
                        </Badge>
                        <Badge variant="surface">{item.card_number}</Badge>
                      </VStack>
                    </Table.Cell> */}

                      <Table.Cell textAlign="center">
                        <Badge variant="surface" colorPalette={item?.type === "deposit" ? "green" : "red"}>
                          {item?.type}
                        </Badge>
                      </Table.Cell>
                      <Table.Cell textAlign="center">{item?.method}</Table.Cell>
                      <Table.Cell textAlign="center">
                        <Badge
                          variant="surface"
                          colorPalette={
                            item?.status === "approved" || item?.status === "success"
                              ? "green"
                              : item?.status === "pending"
                                ? "yellow"
                                : item?.status === "rejected" ||
                                  item?.status === "declined" ||
                                  item.status === "cancelled"
                                  ? "red"
                                  : "gray"
                          }
                        >
                          {item?.status}
                        </Badge>
                      </Table.Cell>

                      <Table.Cell textAlign="center" fontSize="xs">
                        {formatDateTime(item.createdAt)}
                      </Table.Cell>
                      {/* <Table.Cell textAlign="center">
                        <Icon
                          as={FaInfoCircle}
                          variant="surface"
                          size="lg"
                          rounded="full"
                          cursor="pointer"
                          color="gray.500"
                          transition="color 0.1s ease-in-out"
                          _hover={{ color: "gray.700" }}
                          onClick={() => {
                            setTransactionInfoDialogOpen(true);
                            setSelectedToken(item.token);
                          }}
                        />
                      </Table.Cell> */}
                    </Table.Row>
                  ))
                ) : (
                  <Table.Row>
                    <Table.Cell colSpan={8} textAlign="center">
                      No transactions found for the selected criteria.
                    </Table.Cell>
                  </Table.Row>
                )}
              </Table.Body>
            </Table.Root>
          </Table.ScrollArea>
          <CustomPagination totalCount={totalPages} current={currentPage} setCurrent={setCurrentPage} />
        </>
      )}
      {selectedToken !== "" && transactionInfoDialogOpen && (
        <TransactionInfoDialog
          token={selectedToken}
          setToken={setSelectedToken}
          transactionInfoDialogOpen={transactionInfoDialogOpen}
          setTransactionInfoDialogOpen={setTransactionInfoDialogOpen}
        />
      )}
    </VStack>
  );
};